import { EpgApi } from './EpgApi';
import { BaseCachedApi } from './BaseCachedApi';
import { IChannelRightsV5 } from './models/AndromeTV.types';
import { Backend } from './Backend';
import { SettingsKeys } from './models/TranslationKeys';

export class CachedChannelRightsApi extends BaseCachedApi {
  protected override _cache!: IChannelRightsV5[];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(backend: Backend) {
    super();
    this.updateGlobalSettings();
  }

  private updateGlobalSettings() {
    this.updateExpirations(120000, 120000);
  }

  getOttChannelRights(backend: Backend, reload = false): Promise<IChannelRightsV5[]> {
    if (reload) this.bypassCache(true);
    return this.checkCache(backend).then(() => {
      return this._cache;
    });
  }
  override fillCache(backend: Backend): Promise<unknown> {
    this.clearCache();
    return EpgApi.channelRights(backend).then(result => {
      this._cache = result;
    });
  }
}
